import axios from 'axios';
import Env from './Env'
// import Bus from './bus'

function getBaseUrl() {
  return '/'
    // if (Env.isLocal) {
    //     return '/'
    // } else if (Env.isTest) {
    //     return '//t.m.3839.com'
    // } else {
    //     return process.env.NODE_ENV === 'production' ? '//m.3839.com' : "/"
    // }
}
const instance = axios.create({
    baseURL: getBaseUrl(),
    timeout: 20000,
    headers: {
      'Accept': "application/json",
      "Content-Type": "application/x-www-form-urlencoded"
    }
});

function requestInter(config) {
    // if (!Env.isYouPai&& !Env.isGameBox) {
    //   //Bus.$emit("wrong-platform")
    //   return null;
    // }
    // if (!config.params) {
    //   config.params = {}
    // }
    // config.params.scookie = sessionStorage.getItem("cookie");
    // config.params.deviceId = sessionStorage.getItem("deviceId");
    // config.params.plat = Env.isGameBox ? "gamebox" : "other";
  
    return config;
  }
  
  function responseInter(res) {
    // if (res.data.code == "300") {
    //   Bus.$emit("go-login")
    // }
    return res.data    
  }
  
  function responseErrInter(error) {
    return Promise.reject(error);
  }
  
instance.interceptors.request.use(requestInter);
instance.interceptors.response.use(responseInter, responseErrInter);

function get(url, params) {
  return instance.get(url, {params: params})
}

function post(url, params) {    
    let form = new FormData();
    for (let i in params) {
        form.append(i, params[i])
    }
    return instance.post(url, form)
}

export default {
    instance,
    get,
    post
}